import { Link, Typography } from "@material-ui/core";
import { useMatch, useResolvedPath, useLocation } from "react-router-dom";
import { CustomRouterLink } from "./CustomRouterLink";

type HeaderLinkProps = React.PropsWithChildren<{
  targetUrl: string;
  isExternal?: boolean;
}>;

export const HeaderLink = (props: HeaderLinkProps) => {
  const location = useLocation();
  let resolved = useResolvedPath(props.targetUrl);
  let match = useMatch({ path: resolved.pathname, end: true });

  if (props.isExternal) {
    return (
      <Link href={props.targetUrl} target="_blank" underline="none">
        <Typography
          color="#0E1011" 
          sx={{
            fontSize: "16px",
          }}
        >
          {props.children}
        </Typography>
      </Link>
    );
  }

  return (
    <CustomRouterLink to={props.targetUrl}>
      <Typography
        color={match ? "primary" : "#0E1011"} 
        sx={{
          fontSize: "16px",
        }}
      >
        {props.children}
      </Typography>
    </CustomRouterLink>
  );
};
